<script>
import { GoogleMap, Marker, Polyline, //useMap
} from "vue3-google-map";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import api from "@/axios";
import Loader from "@/router/views_mobagile/components/loader.vue";
import Swal from "sweetalert2";
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Roteirizador",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Loader, Layout, PageHeader, GoogleMap, Marker, Polyline  },
  watch: {

  },

  data() {
    return {
      title: "Roteirizador",
      items: [
        {
          text: "WMS",
          href: "/",
        },
        {
          text: "Roteirizador",
          active: true,
        },
      ],
      showDetRota: false,
      infoWindowAberto: null,
      pontoSelecionado: null,
      roteirListElk: null,
      loading: true,
      loadingVisitas: false,
      resumoData: {},
      rotaSelecData: {}
    }
  },
  methods: {

    editarEndereco(pessoa_id){
      console.log('editarEndereco')
      const routeData = this.$router.resolve(`/cliente/editar/${pessoa_id}`)
      window.open(routeData.href, '_blank')
    },

    regisEntrega(ordemItem){
      console.log('regisEntrega')
      console.log(this.rotaSelecData)
      this.loadingVisitas = true
      api.post(`${getBaseUrl()}api/roterzdvs`, {
        rotIdData: this.rotaSelecData._id,
        ordem: ordemItem
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.rotaSelecData = res.data[0]
        this.loadingVisitas = false
        this.atualizaDataList()
      })
    },

    excluirRota(){
      console.log('excluirRota')
      console.log(this.rotaSelecData)
      this.showDetRota = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Roteirização",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        console.log('result.value')
        console.log(result.value)
        if (result.value) {
          this.loading = true
          api.delete(`${getBaseUrl()}api/roterzd`, {
            params: {
              'iddata': this.rotaSelecData._id,
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informação excluída com sucesso",
              showConfirmButton: false,
              timer: 1500
            }).then(
                this.atualizaDataList
            )
          })
        }
      })
    },

    changeStatusRota(){
      console.log('changeStatusRota')
      let contTotal = 0.00
      let tempoTotal = 0.00
      let distTotal = 0.00
      let volumesTotal = 0.00
      let pesoTotal = 0.00
      let mcubicTotal = 0.00
      let custoTotal = 0.00
      this.roteirListElk.forEach((roteir) => {
        // console.log('roteir')
        // console.log(roteir.status)
        if (roteir.status === 'A') {
          contTotal += 1.00
          tempoTotal += roteir.rotaelk[0].gog_tempo.total
          distTotal += roteir.rotaelk[0].gog_distancia
          volumesTotal += roteir.rotaelk[0].wrm_volumes_total
          pesoTotal += roteir.rotaelk[0].wrm_peso_total ?? 0
          mcubicTotal += roteir.rotaelk[0].wrm_mcubic_total ?? 0
          custoTotal += roteir.rotaelk[0].gog_custo.total ?? 0
        }
      })
      const horas = Math.floor(tempoTotal / 3600);
      const minutos = Math.floor((tempoTotal % 3600) / 60);
      const distF = Math.floor((distTotal) / 1000);
      const pesoF = Math.floor(pesoTotal);
      this.resumoData = {
        'contagem': contTotal,
        'tempo': `${horas}h ${minutos}m`,
        'distancia': `${distF.toLocaleString('pt-BR')}km`,
        'volumes': `${volumesTotal.toLocaleString('pt-BR')}`,
        'peso': `${pesoF.toLocaleString('pt-BR')}`,
        'mcubic': `${mcubicTotal.toLocaleString('pt-BR')}`,
        'custo': `${custoTotal.toLocaleString('pt-BR')}`,
      }

      this.$nextTick(() => {
        this.centralizarMapaNasRotasAtivas()
      })
    },

    centralizarMapaNasRotasAtivas() {
      const mapRef = this.$refs.mapRef;
      if (!mapRef || !mapRef.map) return;

      const map = mapRef.map;
      const bounds = new window.google.maps.LatLngBounds();
      let temPonto = false;

      this.roteirListElk
          .filter(r => r.status === 'A' && Array.isArray(r.gog_polyline_pontos))
          .forEach(r => {
            r.gog_polyline_pontos.forEach(p => {
              bounds.extend({ lat: p.lat, lng: p.lng });
              temPonto = true;
            });
          });

      if (temPonto) {
        map.fitBounds(bounds);
      }
    },


    decodePolyline(encoded) {
      const points = [];
      let index = 0;
      const len = encoded.length;
      let lat = 0;
      let lng = 0;
      while (index < len) {
        let b;
        let shift = 0;
        let result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        const dlat = ((result & 1) ? ~(result >> 1) : (result >> 1));
        lat += dlat;
        shift = 0;
        result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        const dlng = ((result & 1) ? ~(result >> 1) : (result >> 1));
        lng += dlng;
        points.push({ lat: lat / 1e5, lng: lng / 1e5 });
      }
      // console.log('points')
      // console.log(points)
      return points;
    },

    detalhesRota(evt){
      console.log('detalhesRota')
      // console.log(evt)
      this.rotaSelecData = evt.rotaelk[0]
      this.rotaSelecData.gog_visitas.forEach((visita) => {
        if (visita['inicio']){
          visita['inicio'] = moment(visita['inicio']).format("DD/MM/YYYY HH:mm:ss");
        }
        if (visita['entrega']){
          visita['entrega'] = moment(visita['entrega']).format("DD/MM/YYYY HH:mm:ss");
        }
      })
      this.showDetRota = true
    },

    abrirInfoWindow(rota) {
      console.log('abrirInfoWindow')
      console.log(rota)
      this.pontoSelecionado = rota;
      this.infoWindowAberto = `${rota.id}`;
    },

    fecharInfoWindow() {
      this.pontoSelecionado = null;
      this.infoWindowAberto = null;
    },

    atualizaDataList(){
      console.log('atualizaDataList_roteirizador')
      this.loading = true
      api.get(`${getBaseUrl()}api/roterzd`, {
        params: {}
      }).then(response => {
        console.log('response.roterzd')
        console.log(response)
        let roteirListIni = response.data[0]
        roteirListIni.forEach((roteir) => {
          // console.log('roteir')
          // console.log(roteir)
          if (roteir.rotaelk[0].gog_polyline) {
            roteir['gog_polyline_pontos'] = this.decodePolyline(roteir.rotaelk[0].gog_polyline)
          }
          roteir['status'] = 'A'
        })
        this.roteirListElk = roteirListIni
        this.changeStatusRota()
        this.loading = false
        this.$nextTick(() => {
          this.centralizarMapaNasRotasAtivas()
        })
      })
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatDecimalSeis(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 6});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }


  },

  mounted() {
    console.log('mounted roteirizador_0')
    this.atualizaDataList()
  },

}



</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="loading" style="min-height: 300px;">
    </Loader>

    <div v-if="!loading">

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">

              <div class="row mb-0">

                <div class="col-sm-2">
                  <div class="card">
                    <div class="card-body">
                      <p class="text-muted mb-2">
                        <i class="mdi mdi-location-enter h2 align-middle mb-0 me-3"></i>
                        Rotas
                      </p>
                      <div class="text-end">
                        <h5> {{ resumoData.contagem  }}</h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="card">
                    <div class="card-body">
                      <p class="text-muted mb-2">
                        <i class="mdi mdi-timeline-clock h2 align-middle mb-0 me-3"></i>
                        Tempo
                      </p>
                      <div class="text-end">
                        <h5>{{ resumoData.tempo }}</h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="card">
                    <div class="card-body">
                      <p class="text-muted mb-2">
                        <i class="mdi mdi-car h2 align-middle mb-0 me-3"></i>
                        Distância
                      </p>
                      <div class="text-end">
                        <h5>{{ resumoData.distancia }}</h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="card">
                    <div class="card-body">
                      <p class="text-muted mb-2">
                        <i class="mdi mdi-truck-fast h2 align-middle mb-0 me-3"></i>
                        Trânsito
                      </p>
                      <div class="text-end">
                        <h5>Leve</h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="card">
                    <div class="card-body">
                      <p class="text-muted mb-2">
                        <i class="mdi mdi-credit-card h2 align-middle mb-0 me-3"></i>
                        Pedágio
                      </p>
                      <div class="text-end">
                        <h5>Não calculado</h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="card">
                    <div class="card-body">
                      <p class="text-muted mb-2">
                        <i class="mdi mdi-contain-end h2 align-middle mb-0 me-3"></i>
                        Quantidade
                      </p>
                      <div class="text-end">
                        <h5>{{ resumoData.volumes }} vol</h5>
                      </div>
                    </div>
                  </div>
                </div>

              </div>


              <div class="row">

                <div class="col-sm-2">
                  <div class="card">
                    <div class="card-body">
                      <p class="text-muted mb-2">
                        <i class="mdi mdi-scale-balance h2 text-black align-middle mb-0 me-3"></i>
                        Peso
                      </p>
                      <div class="col-12 text-end">
                        <div>
                          <h5>{{ resumoData.peso }} kg</h5>
                          <span class="badge badge-soft-dark font-size-12">
                          Entregue: 0 kg
                        </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="card">
                    <div class="card-body">
                      <p class="text-muted mb-2">
                        <i class="mdi mdi-cube h2 text-black align-middle mb-0 me-3"></i>
                        Cubagem
                      </p>
                      <div class="col-12 text-end">
                        <div>
                          <h5>{{ resumoData.mcubic }} m³</h5>
                          <span class="badge badge-soft-dark font-size-12">
                          Entregue: 0 m³
                        </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="card" style="background-color: rgba(128, 128, 128, 0.1);">
                    <div class="card-body">
                      <p class="text-muted mb-2">
                        <i class="mdi mdi-weight h2 text-warning align-middle mb-0 me-3"></i>
                        Ocupação em Peso
                      </p>
                      <div class="col-12 text-end">
                        <div>
                          <h5>{{ resumoData.peso }} kg</h5>
                          <p class="text-muted text-truncate mb-0">
                            + 0.0012 ( 80% )
                            <i class="mdi mdi-arrow-up ms-1 text-warning"></i>
                          </p>
                          <b-progress :value="80" :max="100" class="mb-4" variant="warning" animated></b-progress>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="card" style="background-color: rgba(128, 128, 128, 0.1);">
                    <div class="card-body">
                      <p class="text-muted mb-2">
                        <i class="mdi mdi-eye-outline h2 text-success align-middle mb-0 me-3"></i>
                        Custo Frete
                      </p>
                      <div class="col-12 text-end">
                        <div>
                          <h5>R$ {{ resumoData.custo }} </h5>
                          <p class="text-muted text-truncate mb-0">
                            + 0.0012 ( 80% )
                            <i class="mdi mdi-arrow-up ms-1 success"></i>
                          </p>
                          <b-progress :value="80" :max="100" class="mb-4" variant="success" animated></b-progress>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

      </div>


      <div class="row">

        <div class="col-lg-2" v-for="rotaData of roteirListElk" :key="rotaData.id">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted">
                        <a @click="detalhesRota(rotaData)"
                           href="javascript: void(0);">
                        <span class="badge font-size-12" :style="'background-color: ' + rotaData.rotaelk[0].wrm_cor + '; color: white;'">
                          Rota: {{ rotaData.rota }}
                        </span>
                          <p class="mb-0 mt-2">{{ formatDecimalSeis(rotaData.rotaelk[0].wrm_mcubic_total) }} m³</p>
                        </a>
                      </div>
                    </div>
                    <b-form-checkbox
                        id="statusPessoa"
                        switch
                        size="md"
                        value="A"
                        unchecked-value="I"
                        @change="changeStatusRota"
                        v-model="rotaData.status">
                    </b-form-checkbox>
                  </div>
                  <b-progress :value="rotaData.rotaelk[0].entrega_mcubic" :max="rotaData.rotaelk[0].wrm_mcubic_total" class="mb-4" variant="primary" animated></b-progress>
                  <span class="float-end">
                    {{ ((Number(rotaData.rotaelk[0].entrega_mcubic ?? 0) / Number(rotaData.rotaelk[0].wrm_mcubic_total ?? 1)) * 100).toFixed(2) }}%
                  </span>

                  <div class="row">
                    <div class="col-12">
                      <div>
                        <p class="text-muted text-truncate mb-2">
                          <i class="mdi mdi-car ms-1 success"></i>
                          {{ rotaData.rotaelk[0].gog_veiculo.nome }}</p>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>



      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <GoogleMap
                  ref="mapRef"
                  api-key="AIzaSyCVKQSkNnKrrqz10cxEicsBX8nTxtH9h4c"
                  :center="{ lat: -14.235, lng: -51.925 }"
                  :zoom="5"
                  style="height: 600px">
                <template v-for="rota in roteirListElk.filter(r => r.status === 'A')" :key="rota.id" >
                  <template v-for="(ponto, index) in rota.rotaelk[0].gog_visitas"
                            :key="`pontoTemp-${index}`">
                    <Marker
                        :options="{
                        position: ponto,
                        label: {
                          text: String(ponto.ordem),
                          color: '#FFFFFF',
                          fontSize: '14px',
                          fontWeight: 'bold'
                        },
                        icon: {
                          path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z',
                          fillColor: String(rota.rotaelk[0].wrm_cor),
                          fillOpacity: 1,
                          strokeWeight: 2,
                          strokeColor: '#FFFFFF',
                          scale: 1.5,
                          labelOrigin: { x: 12, y: 10 }
                        }
                      }"
                        @click="abrirInfoWindow(ponto)"
                    />
                  </template>
                  <Polyline
                      :options="{
                      path: rota.gog_polyline_pontos,
                      geodesic: true,
                      strokeColor: rota.rotaelk[0].wrm_cor,
                      strokeOpacity: 0.5,
                      strokeWeight: 5
                    }"
                  />

                </template>

              </GoogleMap>
              <div
                  v-if="pontoSelecionado"
                  class="custom-info-window"
                  :style="{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    zIndex: 1000,
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                    padding: '15px',
                    minWidth: '280px',
                    maxWidth: '350px'
                  }">
                <div class="d-flex justify-content-between align-items-start mb-2">
                  <h6 :style="`color: ${pontoSelecionado.cor}; font-weight: bold; margin: 0;`">
                    <i class="bx bx-map-pin"></i> {{ pontoSelecionado.ordem }}
                  </h6>
                  <button
                      @click="fecharInfoWindow"
                      class="btn-close"
                      style="font-size: 12px;">
                  </button>
                </div>
                <hr class="my-2">
                <p class="mb-1"><strong>Endereço:</strong> {{ pontoSelecionado.endereco }}</p>
                <p class="mb-1"><strong>Ponto:</strong> {{ pontoSelecionado.lat }}, {{ pontoSelecionado.lng }}</p>
                <hr class="my-2">
                <div class="d-flex justify-content-between mb-1">
                  <span><strong>Peso:</strong></span>
                  <span class="badge badge-soft-primary">{{ pontoSelecionado.peso }} kg</span>
                </div>
                <div class="d-flex justify-content-between mb-1">
                  <span><strong>Cubagem:</strong></span>
                  <span class="badge badge-soft-primary">{{ pontoSelecionado.mcubic }} m³</span>
                </div>
                <div class="d-flex justify-content-between mb-1">
                  <span><strong>Valor:</strong></span>
                  <span class="badge badge-soft-success">R$ {{ pontoSelecionado.valor }}</span>
                </div>
                <div class="d-flex justify-content-between">
                  <span><strong>Volumes:</strong></span>
                  <span class="badge badge-soft-info">{{ pontoSelecionado.volumes }} vol</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>



    <b-modal size="lg"
             :title="'Detalhes Rota ' + rotaSelecData.wrm_rota"
             v-model="showDetRota" centered hide-footer>
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">

              <Loader v-if="loadingVisitas" style="min-height: 100px;">
              </Loader>

              <div class="timeline" v-if="!loadingVisitas">
                <div v-for="(item) in rotaSelecData.gog_visitas" :key="item.ordem" class="timeline-item">
                  <div class="timeline-line"></div>
                  <div class="timeline-number">{{ item.ordem }}</div>
                  <div class="timeline-content">
                    <div class="d-flex justify-content-between align-items-start mb-2" >
                      <b-dropdown
                          :disabled="item.ordem === 0"
                          variant="outline-primary"
                          toggle-class="btn btn-outline-primary mx-2"
                          menu-class="dropdown-menu-end">
                        <template #button-content>
                          <i class="bx bx-cog font-size-16 align-middle me-2"></i>
                          {{ item.nome }}
                        </template>
                        <b-dropdown-item href="#" @click="editarEndereco(item.pessoa_id)"> Editar Endereço </b-dropdown-item>
                        <b-dropdown-item href="#" @click="regisEntrega(item.ordem)" :disabled="!!item.entrega"> Registrar Entrega </b-dropdown-item>
                      </b-dropdown>

                      <span class="badge bg-primary" v-if="item.ordem > 0">Tempo: {{ formatDecimal(item.tempo/60) }}m</span>
                    </div>
                    <p class="text-muted mb-2">
                      <i class="bx bx-map-pin me-1"></i>{{ item.endereco }}
                    </p>
                    <div class="d-flex justify-content-between align-items-start mb-2" v-if="item.ordem > 0">
                      <h5 class="text-muted mb-2"><i class="bx bx-time me-1"></i>{{ item.inicio }}</h5>
                      <span class="badge bg-success" v-if="item.entrega">Entrega: {{ item.entrega }}</span>
                    </div>
                    <div class="d-flex flex-wrap gap-2 mt-3" v-if="item.ordem > 0">
                      <span class="badge badge-soft-dark font-size-12">
                        <i class="bx bx-package me-1"></i>{{ item.peso }} kg
                      </span>
                      <span class="badge badge-soft-dark font-size-12">
                        <i class="bx bx-cube me-1"></i>{{ formatDecimalSeis(item.mcubic) }} m³
                      </span>
                      <span class="badge badge-soft-success font-size-12">
                        <i class="bx bx-dollar me-1"></i>R$ {{ formatDecimal(item.valor) }}
                      </span>
                      <span class="badge badge-soft-info font-size-12">
                        <i class="bx bx-box me-1"></i>{{ formatInteger(item.volumes) }} vol
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">

        <div class="text-end mt-5">
          <b-button variant="light" @click="showDetRota = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
          <b-button variant="danger" class="ms-1" @click="excluirRota">
            <i class="bx bx-trash font-size-16 align-middle me-2"></i>
            Excluir
          </b-button>
        </div>

      </div>

    </b-modal>


  </Layout>
</template>


<style scoped>


.row.mb-0 .col-sm-2 .card,
.row:not(.mb-0) .col-sm-3 .card {
  margin-bottom: 0.5rem;
}

.row.mb-0 .col-sm-2 .card .card-body,
.row:not(.mb-0) .col-sm-3 .card .card-body {
  padding: 0.75rem;
}


.timeline {
  position: relative;
  padding-left: 50px;
}

.timeline-item {
  position: relative;
  padding-bottom: 30px;
  padding-left: 20px;
}

.timeline-item:last-child {
  padding-bottom: 0;
}

.timeline-line {
  position: absolute;
  left: -35px;
  top: 0;
  bottom: -30px;
  width: 3px;
  background-color: #0066cc;
}

.timeline-item:last-child .timeline-line {
  display: none;
}

.timeline-number {
  position: absolute;
  left: -50px;
  top: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #0066cc;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  z-index: 1;
  border: 3px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0, 102, 204, 0.3);
}

.timeline-content {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border-left: 3px solid #0066cc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.timeline-content:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateX(5px);
}

.timeline-content h5 {
  color: #495057;
  font-size: 16px;
  font-weight: 600;
}

.timeline-content p {
  margin-bottom: 0;
  font-size: 14px;
}
</style>